
export default {
    props: {
        id: {
            type: String,
            default: 'catalog-dropdown',
        },
        sections: {
            type: Array,
            required: true,
        },
        variant: {
            type: String,
            default: 'catalog',
        },
    },
}
